import React, { useState } from 'react';
import './LanguageSelectorWithChatbot.css';
import ChatBot from "./ChatBot";

const LanguageSelectorWithChatbot = () => {
  const [languageSelected, setLanguageSelected] = useState(false);
  const [language, setLanguage] = useState(null);

  const handleLanguageSelect = (lang) => {
    setLanguage(lang);
    setLanguageSelected(true);
  };

  return (
    <div className={`language-selector-widget fade-in ${languageSelected ? 'hide-selector' : ''}`}>
      {!languageSelected ? (
        <>
          <div className="ai-title">Talk with our AI Agent</div>
          <div className="lang-buttons">
            <button onClick={() => handleLanguageSelect('en')}>
              🇬🇧 <span className="lang-text">English</span>
            </button>
            <button onClick={() => handleLanguageSelect('de')}>
              🇩🇪 <span className="lang-text">Deutsch</span>
            </button>
          </div>
        </>
      ) : (
        <div className="fade-in">
          {language === 'en' && <ChatBot language={language} />}
          {language === 'de' && <ChatBot language={language} />}
        </div>
      )}
    </div>
  );
};

export default LanguageSelectorWithChatbot;
